module.exports = __webpack_public_path__ + "img/6.2.c4bb9f1f.jpg";